(function () {
  'use strict';

  angular.module('app').component('featureCategoriesPage', featureCategoryListComponent());

  function featureCategoryListComponent() {
    return {
      controller: FeatureCategoryListCtrl,
      controllerAs: 'vm',
      bindings: {},
      templateUrl: './app/ajs/admin/feature-categories/feature-categories-page.component.html',
    };
  }

  FeatureCategoryListCtrl.$inject = ['FeatureCategoryService', 'LanguageService'];

  function FeatureCategoryListCtrl(FeatureCategoryService, LanguageService) {
    var vm = this;

    // Methods
    vm.onShowItem = onShowItem;

    // Initializers
    getItems();
    getAdditionalLanguages();

    function getItems() {
      vm.loadingItems = true;
      FeatureCategoryService.getFeatureCategories().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.loadingItems = false;
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ get: 'translations', skip_check_role: true }).then(function (
        data
      ) {
        vm.additionalLanguages = data.items;
      });
    }

    function onShowItem(item, mode) {
      FeatureCategoryService.openFeatureCategoryDetailModal(item, vm.additionalLanguages, mode);
    }
  }
})();
